export const formatPhoneNumber = (phone: string | null | undefined) => {
  if (!phone) return '';
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // Format as (XXX) XXX-XXXX for 10 digits, or +X (XXX) XXX-XXXX for 11+ digits
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return cleaned.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
  } else if (cleaned.length > 10) {
    // For international numbers, just add + at the beginning
    return `+${cleaned}`;
  }
  return phone; // Return original if format not recognized
};
